import React from 'react';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import {
  Card,
  CardContent,
  LinearProgress,
  Typography,
  CardActions,
  CardActionArea
} from '@material-ui/core';
import { Person as PersonIcon } from '@material-ui/icons';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useHistory } from 'react-router-dom';

export interface BoardItemProps {
  task: any;
  provided?: DraggableProvided;
  snapshot?: DraggableStateSnapshot;
  isLoading?: boolean;
}

const BoardItem: React.FC<BoardItemProps> = (props: BoardItemProps) => {
  const { task, provided, isLoading } = props;
  const history = useHistory();

  const assignedUser: any | undefined = task.assigned || task.modifiedBy;
  const assignedName = assignedUser
    ? `${assignedUser.firstName} ${assignedUser.lastName}`
    : '';

  const Contents = () => {
    return (
      <>
        {isLoading && <LinearProgress />}
        <CardContent>
          <Typography variant='body1'>{task.name}</Typography>
          <Typography variant='caption'></Typography>
        </CardContent>
        <CardContent className='info'>
          <div className='assigned'>
            <div className='icon-wrapper'>
              <PersonIcon />
            </div>
            {assignedName}
          </div>
          {task.status === 'Approved' && <CheckCircleIcon color='primary' />}
        </CardContent>
      </>
    );
  };

  if (provided) {
    return (
      <Card
        className='task-card'
        ref={provided && provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        onClick={() => {
          history.push(`/portal/admin/training/${task.id}`);
        }}
      >
        <Contents />
      </Card>
    );
  } else {
    return (
      <Card className='task-card'>
        <Contents />
      </Card>
    );
  }
};

export default BoardItem;
